export default "__VITE_ASSET__0bd86701__"